import Header from '../../../components/Header';
import React, { useEffect, useState, useMemo } from 'react';
import { Box, Typography, Button, Grid, useTheme, IconButton, MenuItem, Select, FormControl, useMediaQuery, Dialog, DialogContent, DialogActions } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { tokens } from '../../../theme';
import { format } from 'date-fns';
import 'jspdf-autotable';
import { useNavigate } from 'react-router-dom';
import { deletestore, getstore, getstorepurchase, getstoreUsers, getstorewarehouse } from '../../../redux/slice/store.slice';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Image_URL } from '../../../utils/baseURL';

function PendingPo() {

    const isMobile = useMediaQuery('(max-width:1024px)');
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const userId = localStorage.getItem("id");
    const users = useSelector(state => state.store.users)?.find(user => user?._id == userId);
    const userRole = users?.roleData?.[0]?.roleName;
    const warehouses = useSelector(state => state.store.wareHouse);
    const dispatch = useDispatch();
    const purchase = useSelector(state => state.store.purchase);
    const store = useSelector(state => state.store.Store);

    const memoizedStyles = useMemo(() => ({
        "& .MuiDataGrid-root": {
            border: "none",
        },
        "& .MuiDataGrid-cell": {
            fontSize: "14px  !important"
        },
        "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
        },
        "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
        },
        "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
        },
        "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
        },
        "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
            fontSize: "13px !important",
        },
        "& .MuiDataGrid-cellContent": {
            fontSize: "14px !important"
        },
        "& .css-6hy2kr-MuiDataGrid-root": {
            fontSize: "14px !important"
        },
        "& .css-1v3msgo-MuiTypography-root-MuiDialogContentText-root": {
            fontSize: "14px !important"
        }
    }), [colors]);

    useEffect(() => {
        dispatch(getstore())
        dispatch(getstorepurchase());
        dispatch(getstorewarehouse());
        dispatch(getstoreUsers());
    }, [dispatch]);

    const getCompletedSteps = (liasoningItem) => {

        if (!liasoningItem) return 0;
        const stepFields = ['SrNo', '', '', '', ''];
        let completedSteps = 0;
        for (const field of stepFields) {
            if (liasoningItem[field]) {
                completedSteps++;
            } else {
                break;
            }
        }
        return completedSteps;
    };

    const handleStep = (itemId, step) => {
        setActiveSteps((prev) => {
            const newSteps = { ...prev, [itemId]: step };
            for (let i = 0; i < step; i++) {
                newSteps[itemId] = i + 1;
            }
            return newSteps;
        });
    };
    const [activeSteps, setActiveSteps] = React.useState({});
    const [itemFilledSteps, setItemFilledSteps] = useState({});
    const [filledSteps, setFilledSteps] = useState([]);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const navigate = useNavigate()
    // const imgUrl ='https://solar-backend-teal.vercel.app';
    const imgUrl = Image_URL;

    const [deleteStoreId, setDeleteStoreId] = useState(null);

    const confirmDelete = () => {
        if (deleteStoreId) {
            dispatch(deletestore(deleteStoreId)).then(() => {
                dispatch(getstore());
            });
            setDeleteConfirmOpen(false);
            setDeleteStoreId(null);
        }
    }

    const handleDelete = (itemId) => {
        setDeleteStoreId(store.find(s => s.purchase === itemId)?._id);
        setDeleteConfirmOpen(true);
    };

    const getCurrentDate = () => {
        return format(new Date(), 'dd-MM-yyyy');
    };

    useEffect(() => {
        setActiveSteps({ ...activeSteps });
    }, []);

    useEffect(() => {
        const initialSteps = {};
        const initialFilledSteps = {};
        purchase.forEach(item => {
            initialSteps[item._id] = item.completedSteps || 0;
            initialFilledSteps[item._id] = item.filledSteps || [];
        });
        setActiveSteps(initialSteps);
        setItemFilledSteps(initialFilledSteps);
    }, [dispatch]);


    const handleEdit = (itemId) => {
        

        const entry = store?.some((store) => store.purchase === itemId) 

        console.log("statusLPP", itemId, store, entry);
        
        navigate('/admin/add-store', { state: { id: itemId, isEdit: true, status: 'Complete', statusL: entry } });
    };

    const [dialogOpen, setDialogOpen] = useState(false);
    const [fileUrl, setFileUrl] = useState('');
    const [isImage, setIsImage] = useState(false);

    const handleOpenDialog = (url, isImage) => {
        setFileUrl(url);
        setIsImage(isImage);
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const [selectedWarehouse, setSelectedWarehouse] = useState("Select Warehouse");
    const [statusFilter, setStatusFilter] = useState('all');

    const handleStatusChange = (event) => {
        setStatusFilter(event.target.value);
    };

    const isStoreComplete = (storeEntry) => {
        console.log("storeEntry", storeEntry);
        
        if (!storeEntry) return false;
        return storeEntry.multipleQty.every(item =>
            Number(item.recieveQtyforstore) >= Number(item.TotalQty)
        );
    };

    const filteredPurchase = useMemo(() => {
        if (statusFilter === 'all') return purchase;

        return purchase.filter(v => {
            const storeEntry = store?.find((s) => s.purchase === v._id);
            if (statusFilter === 'complete') {
                return isStoreComplete(storeEntry);
            } else {
                return !isStoreComplete(storeEntry);
            }
        });
    }, [purchase, store, statusFilter]);
    const isMobileee = useMediaQuery('(max-width:500px)');


    return (
        <Box m="2px" sx={{ overflow: isMobileee ? 'auto' : 'hidden', }}>
            <Header
                title="PENDING PO"
                subtitle="Manage Your Pending PO Here"
            />

            <Box sx={{ display: { xs: "block", md: "flex" }, justifyContent: 'space-between' }}>
                {
                    userRole === 'Super Admin' && (
                        <FormControl size="small" sx={{ mr: 2, mb: { xs: '10px' } }} >
                            <Select
                                value={selectedWarehouse}
                                onChange={(event) => {
                                    setSelectedWarehouse(event.target.value);
                                }}
                                sx={{
                                    minWidth: '200px',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#566585',
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#566585',
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#566585',
                                        borderWidth: '2px',
                                    },
                                }}
                            >
                                <MenuItem value="Select Warehouse">Select Warehouse</MenuItem>

                                {warehouses?.map((warehouse) => (
                                    <MenuItem key={warehouse._id} value={warehouse.wareHouseName}>
                                        {warehouse.wareHouseName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )
                }

                <FormControl size="small" sx={{ mr: 2 }}>
                    <Select
                        value={statusFilter}
                        onChange={handleStatusChange}
                        sx={{
                            minWidth: '200px',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#566585',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#566585',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#566585',
                                borderWidth: '2px',
                            },
                        }}
                    >
                        <MenuItem value="all">All Status ({purchase.length})</MenuItem>
                        <MenuItem value="pending">Pending ({
                            purchase.filter(v => !isStoreComplete(store.find(s => s.purchase === v._id))).length
                        })</MenuItem>
                        <MenuItem value="complete">Complete ({
                            purchase.filter(v => isStoreComplete(store.find(s => s.purchase === v._id))).length
                        })</MenuItem>
                    </Select>
                </FormControl>
            </Box>

            {filteredPurchase.length > 0 ? (
                filteredPurchase.filter(v =>
                    selectedWarehouse === "Select Warehouse" ||
                    (userRole === 'Super Admin' ? warehouses?.find((w) => w._id === v.werehouse)?.wareHouseName : warehouses?.wareHouseName) === selectedWarehouse
                ).map((v) => {
                    const relatedStoreEntries = store.filter(s => s.purchase === v._id);
                    const totalReceivedQty = relatedStoreEntries.reduce((acc, curr) => {
                        return acc + curr.multipleQty.reduce((sum, item) => sum + item.recieveQtyforstore, 0);
                    }, 0);

                    return (
                        <Box className="padding_box" sx={{
                            m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2, bgcolor: theme.palette.mode === 'dark' ? '#293040' : "#E5F1FD", color: theme.palette.mode === 'dark' ? 'white' : "black",
                            overflowX: 'auto',
                        }} key={v._id}
                        >
                            <Grid container item>
                                {!isMobile && (
                                    <Grid item sx={{ flexGrow: 1 }}>
                                        <Box sx={{ whiteSpace: 'pre-line', display: 'flex', flexGrow: 1 }}>
                                            <Box sx={{ width: '250px' }}>
                                                <ul>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>PO Date</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Purchase Order Number</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>PO Value</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Vendor</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Ship To</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Payment Against PO</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Material Recived Against PO</li>
                                                </ul>
                                            </Box>
                                            <Box sx={{ width: '300px' }}>
                                                <ul>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {v.PurchaseDate ? format(new Date(v.PurchaseDate), 'dd-MM-yyyy') : 'N/A'}
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;{v.SrNo}</li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {v.amountTotal % 1 === 0 ? `${v.amountTotal.toFixed(0)}` : `${v.amountTotal.toFixed(2)}`}
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {
                                                            v.vendorDetails[0]?.businessName
                                                        }
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {
                                                            v.wareHouseDetails?.[0].wareHouseName
                                                        }
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {
                                                            (() => {
                                                                const percentage = ((Number(v.venderPayments[0]?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / v.amountTotal || 0;
                                                                return percentage % 1 === 0 ? `${percentage.toFixed(0)}%` : `${percentage.toFixed(3)}%`;
                                                            })()
                                                        }
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {((totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)) % 1 === 0)
                                                            ? `${(totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)).toFixed(0)}%`
                                                            : `${(totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)).toFixed(2)}%`
                                                        }
                                                    </li>
                                                </ul>
                                            </Box>
                                            <Box sx={{ width: '200px' }}>
                                                <ul style={{ marginLeft: '20px' }}>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Recieve Date</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Total Amount</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Total GST</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Grand Total</li>
                                                    <li style={{ listStyleType: 'none', fontWeight: '600' }}>Store Upload File</li>
                                                </ul>
                                            </Box>
                                            <Box sx={{ width: '200px' }}>
                                                <ul>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {
                                                            store?.find((s) => s.purchase === v._id)?.storedate ? format(new Date(store?.find((s) => s.purchase === v._id)?.storedate), 'dd-MM-yyyy') : 'N/A'
                                                        }
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {Number(store?.filter(s => s.purchase === v._id)
                                                            .reduce((acc, curr) => acc + curr.taxableAmount, 0) || 0)}
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {Number(store?.filter(s => s.purchase === v._id)
                                                            .reduce((acc, curr) => acc + curr.totalGstAmount, 0) || 0)}
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {Number(store?.filter(s => s.purchase === v._id)
                                                            .reduce((acc, curr) => acc + curr.amountTotal, 0) || 0)}
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>&nbsp;
                                                        {
                                                            store?.find((store) => store.purchase === v._id)?.storeuploadFile ? (
                                                                <span onClick={() => handleOpenDialog(`${imgUrl}/${store.find((store) => store.purchase === v._id)?.storeuploadFile}`, !store.find((store) => store.purchase === v._id)?.storeuploadFile.endsWith('.pdf'))} style={{ cursor: 'pointer' }}>
                                                                    <VisibilityIcon />
                                                                </span>
                                                            ) : 'No file available'
                                                        }
                                                    </li>
                                                </ul>
                                            </Box>
                                            <Box sx={{ flexGrow: 1 }}>
                                                <Grid sx={{ textAlign: 'start', marginBottom: 2, display: 'flex', alignItems: 'center', justifyContent: "flex-end", flexGrow: 1, flexWrap: "nowrap" }}>
                                                    <Box sx={{
                                                        backgroundColor: isStoreComplete(store?.find((store) => store.purchase === v._id))
                                                            ? 'green'
                                                            : '#9b2323',
                                                        mr: 2,
                                                        padding: "8px 12px",
                                                        borderRadius: '4px'
                                                    }}>
                                                        <Typography sx={{ color: 'white' }}>
                                                            {
                                                                isStoreComplete(store?.find((store) => store.purchase === v._id))
                                                                    ? 'Complete'
                                                                    : 'Pending'
                                                            }
                                                        </Typography>
                                                    </Box>
                                                    <IconButton aria-label="edit" style={{ color: "white", backgroundColor: "#134670" }} sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }}
                                                        onClick={() => handleEdit(v._id)}
                                                    >
                                                        <EditIcon />
                                                    </IconButton>
                                                </Grid>
                                            </Box>
                                        </Box>
                                    </Grid >
                                )}
                                {isMobile ? (
                                    <>
                                        <Grid item>
                                            <Box sx={{ whiteSpace: 'pre-line', display: 'flex' }}>
                                                <Box sx={{ width: '250px' }}>
                                                    <ul>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>PO Date</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Purchase Order Number</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>PO Value</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Vendor</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Ship To</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Payment Against PO</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Material Recived Against PO</li>
                                                    </ul>
                                                </Box>
                                                <Box sx={{ width: '300px' }}>
                                                    <ul>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {v.PurchaseDate ? format(new Date(v.PurchaseDate), 'dd-MM-yyyy') : 'N/A'}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;{v.SrNo}</li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {v.amountTotal % 1 === 0 ? `${v.amountTotal.toFixed(0)}` : `${v.amountTotal.toFixed(2)}`}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {
                                                                v.vendorDetails[0]?.businessName
                                                            }
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {
                                                                v.wareHouseDetails?.[0].wareHouseName
                                                            }
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {
                                                                (() => {
                                                                    const percentage = ((Number(v.venderPayments[0]?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / v.amountTotal || 0;
                                                                    return percentage % 1 === 0 ? `${percentage.toFixed(0)}%` : `${percentage.toFixed(3)}%`;
                                                                })()
                                                            }
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {((totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)) % 1 === 0)
                                                                ? `${(totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)).toFixed(0)}%`
                                                                : `${(totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)).toFixed(2)}%`
                                                            }
                                                        </li>
                                                    </ul>
                                                </Box>
                                                <Box sx={{ width: '250px' }}>
                                                    <ul style={{ marginLeft: '20px' }}>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Recieve Date</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Total Amount</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Total GST</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Grand Total</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Store Upload File</li>
                                                    </ul>
                                                </Box>
                                                <Box sx={{ width: '200px' }}>
                                                    <ul>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {
                                                                store?.find((s) => s.purchase === v._id)?.storedate ? format(new Date(store?.find((s) => s.purchase === v._id)?.storedate), 'dd-MM-yyyy') : 'N/A'
                                                            }
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {Number(store?.filter(s => s.purchase === v._id)
                                                                .reduce((acc, curr) => acc + curr.taxableAmount, 0) || 0)}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {Number(store?.filter(s => s.purchase === v._id)
                                                                .reduce((acc, curr) => acc + curr.totalGstAmount, 0) || 0)}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {Number(store?.filter(s => s.purchase === v._id)
                                                                .reduce((acc, curr) => acc + curr.amountTotal, 0) || 0)}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>&nbsp;
                                                            {
                                                                store?.find((store) => store.purchase === v._id)?.storeuploadFile ? (
                                                                    <span onClick={() => handleOpenDialog(`${imgUrl}/${store.find((store) => store.purchase === v._id)?.storeuploadFile}`, !store.find((store) => store.purchase === v._id)?.storeuploadFile.endsWith('.pdf'))} style={{ cursor: 'pointer' }}>
                                                                        <VisibilityIcon />
                                                                    </span>
                                                                ) : 'No file available'
                                                            }
                                                        </li>
                                                    </ul>
                                                </Box>
                                                <Box sx={{ textAlign: 'right' }}>
                                                    <Grid sx={{ textAlign: 'start', marginBottom: 2, display: 'flex', alignItems: 'center' }}>
                                                        <Box sx={{
                                                            backgroundColor: isStoreComplete(store?.find((store) => store.purchase === v._id))
                                                                ? 'green'
                                                                : '#9b2323',
                                                            mr: 2,
                                                            padding: "8px 12px",
                                                            borderRadius: '4px'
                                                        }}>
                                                            <Typography sx={{ color: 'white' }}>
                                                                {
                                                                    isStoreComplete(store?.find((store) => store.purchase === v._id))
                                                                        ? 'Complete'
                                                                        : 'Pending'
                                                                }
                                                            </Typography>
                                                        </Box>
                                                        <IconButton aria-label="edit" style={{ color: "white", backgroundColor: "#134670" }} sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }}
                                                            onClick={() => handleEdit(v._id)}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                    </Grid>
                                                </Box>
                                            </Box>
                                        </Grid >

                                    </>
                                ) : (
                                    <>

                                    </>
                                )
                                }
                            </Grid >
                        </Box >

                    )
                })
            ) : (
                <Box>
                    <Typography variant="h5" color="textSecondary" align="center">
                        No Results Found. Please Try a Different Search Term.
                    </Typography>
                </Box>
            )}
            <Dialog open={dialogOpen} onClose={handleCloseDialog}>
                <DialogContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {isImage ? (
                        <img src={fileUrl} alt="Preview" style={{ width: '700px', height: 'auto', objectFit: 'contain' }} />
                    ) : (
                        <iframe src={fileUrl} style={{ width: "800px", height: "80vh" }} title="PDF Viewer" />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} sx={{ color: theme.palette.text.primary }}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteConfirmOpen} onClose={() => setDeleteConfirmOpen(false)}>
                <DialogContent>
                    Are you sure you want to delete this store?
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteConfirmOpen(false)} style={{ color: theme.palette.text.primary }}>No</Button>
                    <Button onClick={confirmDelete} style={{ color: theme.palette.text.primary }}>Yes</Button>
                </DialogActions>
            </Dialog>

        </Box >


    );
}

export default PendingPo;
